var render = function render(){
  var _vm$dispatchRequest$d;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', {
    staticClass: "mb-5"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _c('div', [_c('b-modal', {
    attrs: {
      "id": "switchCarrierModal",
      "title": "Wijzig vervoerder en/of bezorgwijze",
      "size": "md",
      "centered": "",
      "dialog-class": "shadow-none"
    },
    on: {
      "ok": _vm.changeCarrier
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function (_ref) {
        var cancel = _ref.cancel,
          ok = _ref.ok;
        return [_c('b-btn', {
          attrs: {
            "variant": "secondary",
            "disabled": _vm.isSavingCarrier
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Annuleren")]), _c('b-btn', {
          attrs: {
            "variant": "primary",
            "disabled": _vm.isSavingCarrier || _vm.selectedCarrierMethod === _vm.dispatchRequest.carrier_method.identifier
          },
          on: {
            "click": _vm.changeCarrier
          }
        }, [!_vm.isSavingCarrier ? _c('span', [_vm._v("OK")]) : _c('font-awesome-icon', {
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        })], 1)];
      }
    }])
  }, [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("Vervoerder:")]), _c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [!_vm.isOnlyOneCarrierAvailable ? _c('span', _vm._l(_vm.carriers, function (carrier) {
    return _c('div', {
      key: carrier.identifier
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: _vm.selectedCarrier,
        expression: "selectedCarrier",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "mr-2",
      attrs: {
        "name": "carrier",
        "type": "radio",
        "id": carrier.identifier
      },
      domProps: {
        "value": carrier.identifier,
        "checked": _vm._q(_vm.selectedCarrier, carrier.identifier)
      },
      on: {
        "change": function ($event) {
          _vm.selectedCarrier = carrier.identifier;
        }
      }
    }), _c('label', {
      attrs: {
        "for": carrier.identifier
      }
    }, [_vm._v(_vm._s(carrier.display_name))])]);
  }), 0) : _c('span', [_vm._v(_vm._s(_vm.selectedCarrierData.display_name))])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("Bezorgwijze:")]), _c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [!_vm.isOnlyOneCarrierMethodAvailable ? _c('span', _vm._l(_vm.carrierMethods, function (carrierMethod) {
    return _c('div', {
      key: carrierMethod.identifier
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: _vm.selectedCarrierMethod,
        expression: "selectedCarrierMethod",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "mr-2",
      attrs: {
        "name": "carrier_method",
        "type": "radio",
        "id": carrierMethod.identifier
      },
      domProps: {
        "value": carrierMethod.identifier,
        "checked": _vm._q(_vm.selectedCarrierMethod, carrierMethod.identifier)
      },
      on: {
        "change": function ($event) {
          _vm.selectedCarrierMethod = carrierMethod.identifier;
        }
      }
    }), _c('label', {
      attrs: {
        "for": carrierMethod.identifier
      }
    }, [_vm._v(_vm._s(carrierMethod.display_name))])]);
  }), 0) : _c('span', [_vm._v(_vm._s(_vm.selectedCarrierMethodData.display_name))])])], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "unableToShipModal",
      "title": "Kan niet leveren",
      "size": "md",
      "centered": "",
      "dialog-class": "shadow-none"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function (_ref2) {
        var cancel = _ref2.cancel;
        return [_c('b-btn', {
          attrs: {
            "variant": "secondary",
            "disabled": _vm.isSavingCarrier
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Annuleren")]), _c('b-btn', {
          attrs: {
            "variant": "danger",
            "disabled": _vm.isFinishing
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.unableToShip.apply(null, arguments);
            }
          }
        }, [!_vm.isFinishing ? _c('span', [_vm._v("Kan niet leveren")]) : _c('font-awesome-icon', {
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        })], 1)];
      }
    }])
  }, [[_c('b-row', [_c('b-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "3"
    }
  }, [_vm._v("Reden:")]), _c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, _vm._l(_vm.unableToShipReasons, function (display_name, identifier) {
    return _c('div', {
      key: identifier
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: _vm.unableToShipSelectedReason,
        expression: "unableToShipSelectedReason",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "mr-2",
      attrs: {
        "name": "reason",
        "type": "radio",
        "id": identifier
      },
      domProps: {
        "value": identifier,
        "checked": _vm._q(_vm.unableToShipSelectedReason, identifier),
        "innerHTML": _vm._s(display_name)
      },
      on: {
        "change": function ($event) {
          _vm.unableToShipSelectedReason = identifier;
        }
      }
    }), _c('label', {
      attrs: {
        "for": identifier
      }
    }, [_vm._v(_vm._s(display_name))])]);
  }), 0)], 1)]], 2), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm.isScannable && !_vm.carriers.length ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_vm._v("Let op:")]), _vm._v(" Deze order heeft het type '" + _vm._s(_vm.dispatchRequest.dispatch_type.display_name) + "'. Hierbij zijn geen vervoerders en/of bezorgwijzen geactiveerd."), _c('br'), _vm._v(" Het is daardoor niet mogelijk deze order te voltooien. ")]) : _vm.isScannable && _vm.selectedCarrier && !_vm.carrierMethods.length && _vm.isOriginalCarrierMethodOverruleable ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_vm._v("Let op:")]), _vm._v(" Deze order heeft als vervoerder '" + _vm._s(_vm.selectedCarrierData.display_name) + "' geselecteerd. Hierbij zijn geen bezorgwijzen geactiveerd."), _c('br'), _vm._v(" Het is daardoor niet mogelijk deze order te voltooien. ")]) : _vm.dispatchRequest.paused_at ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_c('font-awesome-icon', {
    staticClass: "text-danger font-size-xlg align-middle mr-2",
    attrs: {
      "icon": "pause-circle"
    }
  })], 1), _vm._v(" Deze levering is gepauzeerd! Het is niet mogelijk om deze te verwerken totdat deze weer wordt hervat. ")]) : _vm._e(), _c('div', {
    staticClass: "card mb-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm.isScannable ? _c('span', [_vm._v("SCANNEN VAN LEVERING " + _vm._s(_vm.dispatchRequest.sales_order.identifier))]) : _c('span', [_vm._v("BEKIJK ORDER " + _vm._s(_vm.dispatchRequest.sales_order.identifier))])]), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-12 col-sm-6"
  }, [_c('b-table-simple', {
    attrs: {
      "small": "",
      "borderless": ""
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "200px"
    }
  }), _c('col', {
    staticStyle: {
      "width": "auto"
    }
  })]), _c('b-tbody', [_c('b-tr', [_c('b-td', [_c('strong', [_vm._v("Afleveringswijze:")])]), _c('b-td', [_vm._v(_vm._s(_vm.dispatchRequest.dispatch_type.display_name))])], 1), _c('b-tr', [_c('b-td', [_c('strong', [_vm._v("Vervoerder:")])]), _c('b-td', [_c('carrier-icon', {
    staticClass: "carrier-icon d-inline-block align-middle",
    attrs: {
      "carrier": _vm.dispatchRequest.carrier_method.carrier.identifier
    }
  }), _vm._v(" " + _vm._s(_vm.dispatchRequest.carrier_method.carrier.display_name) + " "), _c('span', {
    attrs: {
      "title": !_vm.isSwitchCarrierEnabled ? 'Wijzigen is niet mogelijk voor deze vervoerder/bezorgwijze' : ''
    }
  }, [_c('b-btn', {
    staticClass: "py-0",
    attrs: {
      "variant": "link",
      "size": "sm",
      "disabled": !_vm.isSwitchCarrierEnabled
    },
    on: {
      "click": function ($event) {
        return _vm.$bvModal.show('switchCarrierModal');
      }
    }
  }, [_vm._v("wijzig")])], 1)], 1)], 1), _c('b-tr', [_c('b-td', [_c('strong', [_vm._v("Bezorgwijze:")])]), _vm.selectedCarrierMethodData.display_name ? _c('b-td', [_vm._v(" " + _vm._s(_vm.selectedCarrierMethodData.display_name) + " "), _c('span', {
    attrs: {
      "title": !_vm.isSwitchCarrierEnabled ? 'Wijzigen is niet mogelijk voor deze vervoerder/bezorgwijze' : ''
    }
  }, [_c('b-btn', {
    staticClass: "py-0",
    attrs: {
      "variant": "link",
      "size": "sm",
      "disabled": !_vm.isSwitchCarrierEnabled
    },
    on: {
      "click": function ($event) {
        return _vm.$bvModal.show('switchCarrierModal');
      }
    }
  }, [_vm._v("wijzig")])], 1)]) : _c('b-td', [_c('b-alert', {
    staticClass: "mb-0",
    attrs: {
      "show": "",
      "variant": "warning",
      "size": "sm"
    }
  }, [_vm._v("Onbekend. Mogelijk is de toegewezen bezorgwijze niet geactiveerd voor deze locatie.")])], 1)], 1), _c('b-tr', [_c('b-td', [_c('strong', [_vm._v("Telefoonnummer klant:")])]), _c('b-td', [_vm._v(_vm._s(_vm.billingAddress.phone_number))])], 1)], 1)], 1), _c('br'), _c('span', {
    staticClass: "d-block d-sm-none float-right mt-n2"
  }, [_vm.showBoxSuggestion(_vm.dispatchRequest) ? _c('span', {
    staticClass: "mr-3"
  }, [_c('strong', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v(_vm._s(_vm.dispatchRequest.box_suggestion.suggested_box.identifier))])]) : _vm._e(), _c('print-labels-button', {
    attrs: {
      "dispatch-request": _vm.dispatchRequest,
      "variant": "outline-primary",
      "size": "xxl"
    }
  })], 1), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("ORDERREGELS")])], 1), _c('div', {
    staticClass: "col-12 col-sm-6 text-right"
  }, [_c('span', {
    staticClass: "d-none d-sm-block"
  }, [_vm.showBoxSuggestion(_vm.dispatchRequest) ? _c('span', {
    staticClass: "mr-1"
  }, [_c('strong', [_vm._v(_vm._s(_vm.dispatchRequest.box_suggestion.suggested_box.identifier))])]) : _vm._e(), _vm._v(" orderbon "), _c('download-packing-slip-button', {
    attrs: {
      "dispatch-request": _vm.dispatchRequest,
      "variant": "outline-primary",
      "size": "lg",
      "ask-label-count": false
    }
  }, [_vm._v("Download")]), ((_vm$dispatchRequest$d = _vm.dispatchRequest.dispatch_type) === null || _vm$dispatchRequest$d === void 0 ? void 0 : _vm$dispatchRequest$d.identifier) !== 'click_and_collect' ? _c('download-packing-slip-button', {
    staticClass: "ml-2",
    attrs: {
      "dispatch-request": _vm.dispatchRequest,
      "variant": "outline-primary",
      "size": "lg",
      "ask-label-count": true
    }
  }, [_vm._v("Extra labels aanvragen")]) : _vm._e(), _c('print-labels-button', {
    staticClass: "ml-2",
    attrs: {
      "dispatch-request": _vm.dispatchRequest,
      "variant": "outline-primary",
      "size": "lg"
    }
  })], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-table-simple', {
    staticClass: "mb-1 order-lines",
    attrs: {
      "stacked": "sm",
      "hover": "",
      "small": "",
      "striped": ""
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "100px"
    }
  }), _c('col', {
    staticStyle: {
      "width": "auto"
    }
  }), _c('col', {
    staticStyle: {
      "width": "15%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "15%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "15%"
    }
  })]), _c('b-thead', [_c('b-tr', [_c('th', [_vm._v("Afbeelding")]), _c('th', [_vm._v("Artikel")]), _c('th', [_c('abbr', {
    staticStyle: {
      "background": "transparent",
      "color": "inherit",
      "border-bottom": "1px dotted #000",
      "cursor": "help"
    },
    attrs: {
      "title": "Aantal artikelen te leveren"
    }
  }, [_vm._v("Leveren")])]), _vm.isScannable ? _c('th', [_c('abbr', {
    staticStyle: {
      "background": "transparent",
      "color": "inherit",
      "border-bottom": "1px dotted #000",
      "cursor": "help"
    },
    attrs: {
      "title": "Aantal artikelen gescand"
    }
  }, [_vm._v("Gescand")])]) : _vm._e(), _vm.isScannable ? _c('th', [_vm._v("Alles gescand?")]) : _vm._e()])], 1), _c('b-tbody', [_vm._l(_vm.dispatchRequestLines, function (dispatchRequestLine, index) {
    var _dispatchRequestLine$, _dispatchRequestLine$2;
    return _c('b-tr', {
      key: index,
      staticClass: "order-info-scan-line"
    }, [_c('b-td', {
      attrs: {
        "stacked-heading": "Afbeelding"
      }
    }, [_vm.getProductImage(dispatchRequestLine.product_identifier) ? _c('img', {
      staticClass: "product-image",
      attrs: {
        "src": _vm.getProductImage(dispatchRequestLine.product_identifier),
        "alt": ""
      },
      on: {
        "click": function ($event) {
          return _vm.$bvModal.show(`product_image_${dispatchRequestLine.product_identifier}`);
        }
      }
    }) : _c('span', [_vm._v(" - ")]), _c('b-modal', {
      attrs: {
        "id": `product_image_${dispatchRequestLine.product_identifier}`,
        "size": "md",
        "title": `${dispatchRequestLine.product_identifier} - ${(_dispatchRequestLine$ = dispatchRequestLine.product_name) !== null && _dispatchRequestLine$ !== void 0 ? _dispatchRequestLine$ : dispatchRequestLine.sales_order_line.product_name} - ${dispatchRequestLine.unit_price}`,
        "hide-footer": true
      },
      on: {
        "hidden": function ($event) {
          var _vm$$refs$scanInput;
          (_vm$$refs$scanInput = _vm.$refs['scanInput']) === null || _vm$$refs$scanInput === void 0 ? void 0 : _vm$$refs$scanInput.focus();
        }
      }
    }, [_c('img', {
      staticStyle: {
        "max-width": "100%"
      },
      attrs: {
        "src": _vm.getProductImage(dispatchRequestLine.product_identifier),
        "alt": ""
      }
    })])], 1), _c('b-td', {
      attrs: {
        "valign": "top",
        "stacked-heading": "Artikel"
      }
    }, [_c('p', {
      staticClass: "mb-0",
      attrs: {
        "data-eans": dispatchRequestLine.sales_order_line.ean_codes
      }
    }, [_vm._v(_vm._s((_dispatchRequestLine$2 = dispatchRequestLine.product_name) !== null && _dispatchRequestLine$2 !== void 0 ? _dispatchRequestLine$2 : dispatchRequestLine.sales_order_line.product_name))]), dispatchRequestLine.release_date ? _c('p', {
      staticClass: "text-primary mb-0 font-weight-bold"
    }, [_vm._v("Release datum: " + _vm._s(dispatchRequestLine.release_date))]) : _vm._e(), _c('p', {
      staticClass: "mb-0 font-11"
    }, [_c('product-number', {
      attrs: {
        "number": dispatchRequestLine.product_identifier,
        "dispatch-request-line": dispatchRequestLine,
        "link-class": "text-secondary"
      }
    })], 1)]), _c('b-td', {
      attrs: {
        "valign": "top",
        "stacked-heading": "Leveren"
      }
    }, [_vm._v(" " + _vm._s(dispatchRequestLine.quantity) + " ")]), _vm.isScannable ? _c('b-td', {
      staticClass: "order-info-scan-quantity-scanned",
      attrs: {
        "valign": "top",
        "stacked-heading": "Gescand"
      }
    }, [_vm._v(" " + _vm._s(dispatchRequestLine.scanned) + " ")]) : _vm._e(), _vm.isScannable ? _c('b-td', {
      staticClass: "order-info-scan-finished",
      attrs: {
        "stacked-heading": "Alles gescand?"
      }
    }, [dispatchRequestLine.scanned === dispatchRequestLine.quantity ? _c('span', {
      staticClass: "iconCheckmark"
    }, [_vm._v("✓")]) : _c('span', [_vm._v("Nee")])]) : _vm._e()], 1);
  }), _vm.dispatchRequest.gift_wrapped ? _c('b-tr', {
    staticClass: "order-info-scan-line"
  }, [_c('b-td', [_vm._v(" ")]), _c('b-td', [_c('strong', [_vm._v("Cadeaupapier")])]), _vm.isScannable ? _c('b-td', [_vm._v("1")]) : _vm._e(), _vm.isScannable ? _c('b-td', [_vm._v(" ")]) : _vm._e()], 1) : _vm._e()], 2)], 1)], 1)])]), _vm.isScannable ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-md-4"
  }, [_c('form', {
    staticClass: "order-info-scan-line-form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.scan.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('b-input', {
    ref: "scanInput",
    staticClass: "order-info-scan-line-input form-control mr-2",
    attrs: {
      "type": "text",
      "autofocus": "",
      "disabled": _vm.isFinishing,
      "title": "Scan barcode"
    },
    model: {
      value: _vm.scanIdentifier,
      callback: function ($$v) {
        _vm.scanIdentifier = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "scanIdentifier"
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.isFinishing
    }
  }, [_vm._v("Verzend EAN code")])], 1)])])]) : _vm._e(), _vm.isScannable ? _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isFinishing
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.$bvModal.show('unableToShipModal');
      }
    }
  }, [_vm._v(" Kan niet leveren ")]), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.canShip
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.ship.apply(null, arguments);
      }
    }
  }, [_vm._v(" Voltooi levering ")])])], 1) : _vm._e(), _vm.usesNewScanProcess ? _c('div', [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.isCreatingBatch
    },
    on: {
      "click": _vm.startNewScanProcess
    }
  }, [_vm._v(" Start verwerking "), _vm.isCreatingBatch ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-md-12 pb-0 pt-0"
  }, [_c('hr', {
    staticClass: "my-1"
  }), _c('h6', [_vm._v("Handmatig barcodes invoeren")])]);

}]

export { render, staticRenderFns }